import { SPELL_ID } from '../ids/spell-id'
import { SpellMap } from 'web/data/models'

export const DH_SPELLS: SpellMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Havoc
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.DH.HAVOC.DARK]: {
        id: SPELL_ID.DH.HAVOC.DARK,
        talentId: undefined,

        name: "Darkness",
        shortName: "Dark",

        cooldown: 180,
        affectedByModifierIds: [],

        game_id: 196718,
        icon_name: "ability_demonhunter_darkness",
    }
}
